module.exports = __webpack_public_path__ + "img/1512582140.f77fa06f.jpg";